export default __webpack_public_path__ + "static/media/App.0822b41f.png";